// extracted by mini-css-extract-plugin
export default {"container":"p88DqN","contentContainer":"bwDSzM"};